import React from "react"
import Meta from "../Meta"
import AccountSpace from "../../../components/AccountSpace"
import {t} from "@lingui/core/macro"

// Wrapper thème 2026 pour l'Espace de compte. Le Header/Footer sont fournis par
// ThemeRoot (commun à toutes les pages du thème) ; ici on ajoute juste le Meta et
// le marginTop sous le header — même pattern que CustomPage du thème 2026 (sinon
// le contenu « Mon espace » colle au header, surtout sur mobile).
export default function AccountSpacePage({context}) {
    const title = t`Mon espace`
    return (
        <>
            <Meta context={context} title={title}/>
            <div style={context.render !== "embed" ? {marginTop: 32, minHeight: "60vh"} : undefined}>
                <AccountSpace context={context}/>
            </div>
        </>
    )
}
